/**
 * MemberPresenter
 * --
 */
import React from 'react';
import { Button, Input, Spin, Checkbox } from 'antd';
import { Col, Content, Row, Text } from 'components';
import { openAddressModal } from 'utils/DaumAPIManager';

const MemberPresenter = (props) => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  const {
    type,
    inputValue,
    isLoading,
    isDuplicate,
    onNavigate,
    onChange,
    onDuplicate,
    onSubmit,
    checkedAll,
    checkedList,
    checkListItem,
    onChecked,
    onCheckedAll,
  } = props;
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  const styles = {
    wrap: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'column',
    },

    submit: {
      marginTop: 24,
      width: '100%',
    },

    link: {
      padding: 0,
    },

    formWrap: {
      display: 'flex',
      flexDirection: 'column',
      gap: 24,
      width: '100%',
      marginTop: 32,
    },
    form: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      gap: 8,
    },
    formItem: {
      display: 'flex',
      alignItems: 'stretch',
      gap: 24,
    },
    label: {
      fontSize: 14,
      color: '#111111',
    },
    required: {
      color: '#D33444',
    },

    button: {
      width: 120,
      padding: 0,
    },
  };

  /* ===== FUNCTION ===== */
  /**
   * 다음 주소 API
   * --
   */
  const handleAddressModal = () => {
    openAddressModal((res) => {
      const { address, zonecode } = res;

      onChange('user_address', address);
      onChange('postcode', zonecode);
    });
  };

  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <React.Fragment>
      <Spin spinning={isLoading}>
        <Content maxWidth={'100%'} padding={0} backgroundColor="#70737C14">
          <Content maxWidth={520}>
            <Row>
              <Col x={24}>
                <Content
                  maxWidth={'100%'}
                  padding={0}
                  style={{ ...styles.wrap }}
                  height={'100vh'}
                >
                  <div style={{ width: '100%' }}>
                    <Text size={24} weight={700}>
                      기존 회원이신가요?
                    </Text>

                    <Text style={{ marginTop: 10 }}>
                      기존 회원 정보를 연동하여 다양한 혜택을 받아보세요!
                    </Text>
                  </div>

                  {type && type !== 'MEMBER' ? (
                    <div
                      style={{
                        ...styles.formWrap,
                      }}
                    >
                      {/* 아이디 */}
                      <div style={{ ...styles.form }}>
                        <Text style={{ ...styles.label }}>
                          아이디 <span style={{ ...styles.required }}>*</span>
                        </Text>
                        <div style={{ ...styles.formItem }}>
                          <Input
                            size="large"
                            value={inputValue?.user_account}
                            placeholder="아이디"
                            onChange={(e) =>
                              onChange('user_account', e.target.value)
                            }
                            disabled={isDuplicate['user_account']}
                          />
                          <Button
                            size="large"
                            type="primary"
                            onClick={() =>
                              onDuplicate(
                                'user_account',
                                inputValue?.user_account
                              )
                            }
                            style={{ ...styles.button }}
                            disabled={isDuplicate['user_account']}
                          >
                            중복검사
                          </Button>
                        </div>
                      </div>

                      {/* 비밀번호 */}
                      <div style={{ ...styles.form }}>
                        <Text style={{ ...styles.label }}>
                          비밀번호 <span style={{ ...styles.required }}>*</span>
                        </Text>
                        <div style={{ ...styles.formItem }}>
                          <Input.Password
                            size="large"
                            value={inputValue?.password}
                            placeholder="비밀번호"
                            onChange={(e) =>
                              onChange('password', e.target.value)
                            }
                          />
                        </div>
                        <div style={{ ...styles.formItem }}>
                          <Input.Password
                            size="large"
                            value={inputValue?.re_password}
                            placeholder="비밀번호 확인"
                            onChange={(e) =>
                              onChange('re_password', e.target.value)
                            }
                          />
                        </div>
                      </div>

                      {/* 약관동의 */}
                      <div style={{ ...styles.form }}>
                        <Text style={{ ...styles.label }}>
                          약관동의 <span style={{ ...styles.required }}>*</span>
                        </Text>
                        <Checkbox
                          checked={checkedAll}
                          onChange={(e) => onCheckedAll(e.target.checked)}
                          style={{ ...styles.checkbox, fontWeight: 700 }}
                        >
                          모두 동의 (선택 정보 포함)
                        </Checkbox>
                        {checkListItem.map((_item, _index) => (
                          <div key={`checkbox_${_item.key}`}>
                            <p style={{ ...styles.checkbox }}>
                              <Checkbox
                                checked={checkedList[_item.key]}
                                onChange={(e) =>
                                  onChecked(_item.key, e.target.checked)
                                }
                                style={{ ...styles.checkbox }}
                              >
                                {_item.label}

                                <span style={{ padding: '0px 5px' }}>
                                  ({_item.required ? '필수' : '선택'})
                                </span>
                              </Checkbox>
                            </p>
                            {_item.url && (
                              <button
                                style={{ ...styles.more }}
                                // onClick={() => navigate(`${_item.url}`)}
                              >
                                보기
                              </button>
                            )}
                          </div>
                        ))}
                      </div>

                      {/* 회원가입 */}
                      <div style={{ ...styles.form }}>
                        <Button
                          size="large"
                          type="primary"
                          style={{ ...styles.submit }}
                          onClick={() => onSubmit(type)}
                        >
                          회원가입
                        </Button>
                      </div>
                    </div>
                  ) : (
                    <React.Fragment>
                      <Button
                        size="large"
                        type="primary"
                        style={{ ...styles.submit, marginBottom: 12 }}
                        onClick={() => onNavigate('AUTH')}
                      >
                        본인인증
                      </Button>

                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          width: '100%',
                          gap: 12,
                        }}
                      >
                        <Text size={14} maxLine={2} color={'#900020'}>
                          중복으로 가입하셨을 경우 최근 가입 시 기입하신 정보로
                          가입됩니다!
                        </Text>
                        <Button
                          type="link"
                          style={{ ...styles.link }}
                          onClick={() => onNavigate('BACK')}
                        >
                          신규가입하기
                        </Button>
                      </div>
                    </React.Fragment>
                  )}
                </Content>
              </Col>
            </Row>
          </Content>
        </Content>
      </Spin>
    </React.Fragment>
  );
};

export default MemberPresenter;
